export default {
  choose_place: 'Chọn ghế',
  pick_up_drop_off: 'Chọn điểm đi/điểm đến',
  enter_information: 'Thông tin khách hàng',
  available: 'Còn trống',
  not_available: 'Đã đặt',
  selected: 'Đang chọn',
  seat: 'Ghế',
  total: 'Tổng cộng',
  continue: 'Tiếp tục',
  pick_up: 'Điểm đi',
  drop_off: 'Điểm đến',
  seat_empty: 'Vui lòng chọn ít nhất 1 vị trí',
  note_placeholder: 'Các yêu cầu khác',
  seats_error: 'Vui lòng chọn ít nhất 1 vị trí',
  pick_up_error: 'Bạn chưa chọn điểm đi',
  drop_off_error: 'Bạn chưa chọn điểm đến',
  seats_limit: 'Chỉ được đặt tối đa 10 vé/SĐT',
  name_error: 'Họ & tên không hợp lệ',
  phone_error: 'Vui lòng nhập đúng định dạng',
  email_error: 'Email không hợp lệ',
  transaction_information: 'Thông tin giao dịch',
  pick_up_expected: 'Điểm đón (dự kiến)',
  pick_up_1: 'Điểm đón',
  drop_off_expected: 'Điểm trả (dự kiến)',
  drop_off_1: 'Điểm trả',
  vehicle_type: 'Loại xe',
  vehicle_name: 'Nhà xe',
  trip_information: 'Thông tin chuyến đi',
  complete_payment: 'Hoàn tất thanh toán',
  complete_booking: 'Hoàn tất đặt vé',
  payment_bank_card: 'Payment via bank card (ATM)',
  direct_payment: 'Thanh toán trực tiếp',
  payment_methods: 'Phương thức thanh toán',
  remaining_payment: 'Thời gian thanh toán còn lại',
  fare: 'Giá vé',
  payment_note: 'Nếu bạn có yêu cầu nào khác, xin hãy nhập nội dung thông điệp ở đây để chúng tôi có thể phục vụ bạn tốt hơn!',
  payment_direct: 'Quý khách sẽ thanh toán tiền mặt cho nhân viên tại văn phòng của chúng tôi',
  payment_atm: 'Quý khách chuyển khoản đến STK bên dưới',
  mb: 'NGÂN HÀNG QUÂN ĐỘI',
  account_number: 'Số TK',
  account_holder: 'Chủ TK',
  status: 'Trạng thái',
  successful_booking: 'Đặt chổ thành công',
  payment_success: 'Thanh toán thành công',
  time: 'Đón lúc',
  order_code: 'Mã đơn hàng',
  cancellation_tickets: 'Hủy vé',
  policy: 'Chính sách',
  cancel_refunds: 'Hủy đơn hàng & hoàn tiền',
  payment_notification: 'Chúng tôi đã gửi thông tin chuyến đi đến email {mail}, bạn hãy kiểm tra thật kĩ nhé!',
  load_data: 'Đang tải thông tin chuyến...',
  cancel_title: 'Xác nhận hủy vé',
  cancel_note: 'Chọn lý do hủy vé',
  cancel_submit: 'Hủy vé',
  back: 'Quay lại',
  cancels: [
    {
      id: 1,
      value: 'Tôi bận nên không đi nữa'
    },
    {
      id: 2,
      value: 'Tôi đặt nhầm giờ/ngày'
    },
    {
      id: 3,
      value: 'Tôi đặt nhầm tuyến đường'
    },
    {
      id: 4,
      value: 'Hãng xe không có tiện ích cần thiết'
    },
    {
      id: 5,
      value: 'Tôi muốn đón dọc đường/trung chuyển nhưng nhà xe không đón'
    },
    {
      id: 6,
      value: 'Bất khả kháng về sức khỏe'
    },
    {
      id: 7,
      value: '*** Lý do khác (dùng ghi chú hủy vé) ***'
    }
  ],
  cancellation_reason_other: 'Vui lòng nhập lý do hủy',
  select_reason: 'Vui lòng chọn lý do hủy',
  enter_reason: 'Vui lòng nhập lí do',
  ticket_cancel: 'Vé đã hủy',
  payment_success_note: 'Vui lòng thanh toán cho mã đặt chỗ <strong>{booking_code}</strong> trước <strong>{booking_time}</strong>.<br>' +
      'Sau thời gian này, các đặt chỗ chưa thanh toán sẽ tự động bị hủy.',
  route: 'Tuyến đường',
  ticket_wrong: 'Thông tin đơn hàng không đúng. Vui lòng thử lại!',
  cancel_note_common: 'Phí hủy được tính trên giá gốc và không vượt quá số tiền bạn đã thanh toán (giá gốc không bao gồm mã giảm giá)',
  min_customer_error: 'Vui lòng chọn ít nhất {min} ghế với điểm đón này',
  min_customer_note: 'Chỉ đón từ {min} khách trở lên',
  maximum_seat: 'Quý khách chỉ được chọn tối đa 8 chỗ cho mỗi lần đặt',
  unfixed_point: 'Vui lòng nhập địa chỉ cụ thể',
  unfixed_point_validate: 'Vui lòng nhập địa chỉ',
  choose_place_note: 'Chuyến này không hỗ trợ chọn chỗ trước',
  surcharge_note_1: ' (Phụ thu {price}đ/người',
  surcharge_note_2: ', Nhà xe thu)',
  ticket_not_able_cancel: 'Vé không thể hủy!',
  cancellation_fee: 'Phí hủy',
  cancellation_sure: 'Bạn chắc chắn muốn hủy?',
  bank_address_label: 'Địa chỉ NH',
  bank_address: 'Số 18, đường Lê Văn Lương, thành phố Hà Nội, Việt Nam.',
  pay_now: 'Thanh toán ngay',
  pay_info: 'Xác nhận thông tin vé',
  total_refund: 'Tổng số tiền hoàn lại',
  cancel_note_1: 'Chúng tôi sẽ liên hệ với bạn trong thời gian sớm nhất hoặc liên hệ với chúng tôi qua email: hoianbusbooking@gmail.com. Xin cảm ơn.',
}
